import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Kor, ModulService } from '../modul.service';
import { Subscription } from 'rxjs';
import { SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';

@Component({
  selector: 'app-naslovnica',
  templateUrl: './naslovnica.component.html',
  styleUrls: ['./naslovnica.component.scss']
})
export class NaslovnicaComponent implements OnInit, OnDestroy {

  constructor(
    private router: Router, 
    public mod: ModulService,
    private authService: SocialAuthService,) { }

  authSubscription!: Subscription;

  ngOnInit() {

    this.authService.signOut();

    if (localStorage.getItem('token') || this.mod.objKor) {
      console.log(this.mod.objKor);
      this.router.navigate(['cpanel1']);
    } else {
      this.mod.btnLoginClass = "Prijava";

      this.authSubscription = this.authService.authState.subscribe((user) => {
        console.log('user', user);
        this.socialLogin(user);
      });

      if (this.mod.poslanEmail) {
        document.getElementById('btnPoslano').click();
        this.mod.poslanEmail = false;
      }

    }

  }

  socialLogin(user: SocialUser) {
    if (user.email) {
      this.mod.socialLogin(user, (rez0: Kor) => {
        if (rez0) {
          this.mod.objKor = rez0;
          document.getElementById('btnLoginModalClose').click();
          this.router.navigate(['cpanel1']);
          /* this.authSubscription.unsubscribe(); */
          this.mod.msgBox(1, "Uspješno ste prijavljeni", 2000);
        } else {
          this.mod.msgBox(2, "Greška prilikom prijave", 2000);
        }
      });
    } else {
      this.mod.msgBox(2, "Greška prilikom prijave", 2000);
    }
  }

  ngOnDestroy(): void {
    document.getElementById('btnPolsanMailClose').click();
  }

}
